/**
 * Mutations for wordpress/settings module
 */
import AppAPI from '@/api'
import types from './types'

function treeShake (state) {
  Object.keys(state).forEach(prop => {
    if (!AppAPI.settingsProps.includes(prop)) delete state[prop]
  })
}

function mutate (state, payload) {
  AppAPI.settingsProps.forEach(prop => { state[prop] = payload && payload[prop] ? payload[prop] : AppAPI.settingsDefault[prop] })
}

const mutations = {
  [types.FETCH]: (state, payload) => {
    treeShake(state)
    mutate(state, payload)
  },
  [types.UPDATE]: (state, payload) => {
    treeShake(state)
    mutate(state, payload)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/settings/mutations.js